

















































































































































































































import { Component, Vue } from 'vue-property-decorator'
import CommonButton from '@/components/common/CommonButton.vue'

@Component({
  components: { CommonButton },
})
export default class Buttons extends Vue {
  private buttonState = {
    textColor: 'purple',
    size: 'medium',
    color: 'marine',
    text: 'large',
    border: 'none',
    rounded: true,
    loaded: false,
    disabled: false,
    radius: 'full',
  }

  private value = false
}
